import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { CertificationsFragmentGql } from './DataQualityCertificationFragmentsGql';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';
import { TableCertificationFragmentGql } from './TableCertificationFragmentGql';
import { TableDatabaseNameFragmentGql } from './TableDatabaseNameFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';


export const TablesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment TablesDisplayGridRowDataFragment on Table {
  __typename
  id
  name
  description
  isEmbedded
  downstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ... on DatabaseTable {
    luid
    contact {
      ...TableauUserFragment
    }
    ...TableCertificationFragment
    ...CertificationsFragment
    dataQualityWarnings {
      ...DataQualityWarningFragment
      ...DataQualityWarningAssetFragment
    }
  }
  ... on VirtualConnectionTable @flag(enabled: $publishedConnectionsLineageEnabled) {
    luid
    vizportalUrlId
    isCertified
    ...CertificationsFragment
    dataQualityWarnings {
      ...DataQualityWarningFragment
      ...DataQualityWarningAssetFragment
    }
    isExtracted
    extractLastRefreshedAt
  }
  ...TableDatabaseNameFragment
  columnsConnection(first: 3, orderBy: { field: NAME, direction: ASC }) {
    totalCount
    nodes {
      name
    }
  }
}
${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
${TableCertificationFragmentGql}
${CertificationsFragmentGql}
${TableDatabaseNameFragmentGql}
${TableauUserFragmentGql}
`;
